import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';

import { IMAGE_HOTSPOT_EVALUATION_CONFIG } from '../../../utils';
import { SubmittedHotspotProps } from './types';

const SubmittedHotspot: React.FC<SubmittedHotspotProps> = (props) => {
  const { text, type } = props;

  const { t } = useTranslation();

  const { labelKey, Icon, iconFillColorToken, textColor } = IMAGE_HOTSPOT_EVALUATION_CONFIG[type];

  return (
    <Stack className="rounded-8 bg-bg-primary p-16" direction="col" gapY={6}>
      <Stack gapX={6}>
        <Icon className="h-20 w-20" fillColorToken={iconFillColorToken} />
        {labelKey ? (
          <Typography color={textColor} variant="label-caps">
            {t(labelKey)}
          </Typography>
        ) : null}
      </Stack>
      <Typography variant="body-short-02">{text}</Typography>
    </Stack>
  );
};

export default SubmittedHotspot;
